export default __webpack_public_path__ + "static/sizzle_desktop-e7918ca302fd4f53a3af943778c68699.mp4";